export default class dataRequest {
  constructor(service) {
    this.service = service;
  }

  getAllFamilyList$() {
    return this.service
      .fetch$({
        method: 'GET',
        url: '/family',
      });
  }


  getFamilyList$(groupId) {
    return this.service
      .fetch$({
        method: 'GET',
        url: `/family?groupId=${groupId}`,
      });
  }

  getFamilyItem$(id) {
    return this.service
      .fetch$({
        method: 'GET',
        url: `/family/${id}`,
      });
  }

  createFamilyItem$(name, groupIds) {
    return this.service
      .fetch$({
        method: 'POST',
        url: '/family/',
        body: {
          name,
          groupIds,
        },
      });
  }

  updateFamilyItem$(id, data) {
    return this.service
      .fetch$({
        method: 'PUT',
        url: `/family/${id}`,
        body: {
          ...data,
        },
      });
  }

  deleteFamilyItem$(id) {
    return this.service
      .fetch$({
        method: 'DELETE',
        url: `/data/read/${id}`,
      });
  }
}
